<template>
	<div class="omapi-guides__guide omapi-omu__grid-item omapi-card__fourth">
		<a v-if="img" class="item-thumb guide-thumb has-thumb" @click="maybeUpsell" :href="url" target="_blank" rel="noopener">
			<img :height="img.height" :width="img.width" :src="img.source_url"/>
		</a>
		<a v-else class="item-thumb guide-thumb no-thumb" @click="maybeUpsell" :href="url" target="_blank" rel="noopener">
			<span class="guide-title" v-html="guide.title"/>
		</a>
		<h4 class="omapi-guides__guide-title">
			<a @click="maybeUpsell" :href="url" target="_blank" rel="noopener" v-html="guide.title"/>
		</h4>
		<a @click="maybeUpsell" :href="url" target="_blank" rel="noopener" class="omapi-link-arrow-after omapi-link-underline">View Guide</a>
	</div>
</template>

<script lang="js">
import { debug } from '@/utils'
import { markingSso } from '@/components/mixins/markingSso'
import { upsell } from '@/university/mixins/upsell'

export default  {
	mixins : [ markingSso, upsell ],
	data () {
		return {
			utmMedium : 'UniversityGuide',
		}
	},
	props : {
		guide : {
			type     : Object,
			required : true,
		},
	},
	computed : {
		url () {
			return this.marketingUrl(this.guide.link, 'University')
		},
		img () {
			let { img } = this.guide

			if (img && debug.enabled('guide-media')) {
				img.source_url = img.source_url.replace('optinmonster.test', 'optinmonster.com')
			}

			return img
		},
	},
}
</script>
